import useMutation from "src/hooks/useMutation";

function useBatchRemove(id, params) {
  const isWHouseId = params?.warehouse ? `?warehouse=${params?.warehouse}` : "";
  return useMutation({
    path: `/api/v1/batches/${id}${isWHouseId}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/batches`,
      shouldRevalidate: true,
    },
  });
}

export default useBatchRemove;
